import Cropper from 'react-cropper'
import '../../styles/imports.css'
import { CARD_PROPORTION } from '../../constants'
import { useCallback, useEffect, useState } from 'react'
import { MAX_CANVAS_PIXELS } from '../../constants'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
    loadingImageContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 177,
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.up('md')]: {
            minHeight: 300,
        },
    },
}))

const NewCardBuilder = ({ imageFile, setCropper, hasAnyImageViolations }) => {
    const classes = useStyles()
    const [imagePreparedForCrop, setImagePreparedForCrop] = useState(null)
    const [originalImageFile, setOriginalImageFile] = useState(null)

    const calculateLimitSize = useCallback((size) => {
        const { width, height } = size

        const requiredPixels = width * height
        if (requiredPixels <= MAX_CANVAS_PIXELS) {
            return { width, height }
        }

        const scalar = Math.sqrt(MAX_CANVAS_PIXELS) / Math.sqrt(requiredPixels)
        return {
            width: Math.floor(width * scalar),
            height: Math.floor(height * scalar),
        }
    }, [])

    useEffect(() => {
        if (imagePreparedForCrop && originalImageFile === imageFile) {
            return
        }

        setOriginalImageFile(imageFile)

        const img = new Image()
        img.onload = () => {
            const calculatedImageSize = calculateLimitSize({
                width: img.width,
                height: img.height,
            })

            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')
            canvas.width = calculatedImageSize.width
            canvas.height = calculatedImageSize.height

            ctx.drawImage(
                img,
                0,
                0,
                calculatedImageSize.width,
                calculatedImageSize.height
            )
            setImagePreparedForCrop(canvas.toDataURL())
        }
        img.src = imageFile
    }, [
        imageFile,
        calculateLimitSize,
        imagePreparedForCrop,
        setImagePreparedForCrop,
        originalImageFile,
        setOriginalImageFile,
    ])

    return (
        <>
            {imagePreparedForCrop ? (
                <Cropper
                    src={imagePreparedForCrop}
                    style={{
                        maxHeight: 400,
                        width: '100%',
                        pointerEvents: !hasAnyImageViolations()
                            ? 'auto'
                            : 'none',
                    }}
                    aspectRatio={CARD_PROPORTION}
                    autoCropArea={0}
                    viewMode={1}
                    guides={true}
                    background={false}
                    responsive={true}
                    rotatable={true}
                    checkOrientation={true}
                    dragMode={'move'}
                    onInitialized={(instance) => {
                        setCropper(instance)
                    }}
                />
            ) : (
                <div className={classes.loadingImageContainer}>
                    <p>Processing...</p>
                </div>
            )}
        </>
    )
}

export default NewCardBuilder
